"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessRequestStatus = void 0;
var AccessRequestStatus;
(function (AccessRequestStatus) {
    AccessRequestStatus["PENDING"] = "pending";
    AccessRequestStatus["ACCEPTED"] = "accepted";
    AccessRequestStatus["REJECTED"] = "rejected";
})(AccessRequestStatus || (exports.AccessRequestStatus = AccessRequestStatus = {}));
